import CustomError from './CustomError'

export default class InvalidRequestDataException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
